module.exports = __webpack_public_path__ + "img/5101e741f03aeafa3682ecfe4788cec7.png";